<template>
    <div class="self-card-detail">
        <div class="booking-form">
            <van-form>
                <van-field label="卡版本:">
                    <template #input>{{ selfCardDetail.card_version_name }}</template>
                </van-field>
                <van-field label="卡类型:">
                    <template #input>{{ selfCardDetail.card_type_name }}</template>
                </van-field>
                <van-field label="服务:">
                    <template #input>
                        <div v-html="serviceNames"></div>
                    </template>
                </van-field>
                <van-field label="是否实体卡:">
                    <template #input>{{ selfCardDetail.is_entity === 1 ? '是' : '否' }}</template>
                </van-field>
                <van-field label="单价:">
                    <template #input>
                        {{ selfCardDetail.price }} 元
                    </template>
                </van-field>
                <div class="cards-table-section">
                    <div class="cards-table-text">每个渠道的开卡数量</div>
                    <div class="cards-table">
                        <div class="cards-table-row">
                            <div class="cards-table-column column2">渠道名称</div>
                            <div class="cards-table-column column2">数量*（张）</div>
                        </div>
                        <div class="cards-table-row" v-for="(channel, index) in selfCardDetail.channel_count" :key="index">
                            <div class="cards-table-column column2">{{ channel.channel_name }}</div>
                            <div class="cards-table-column column2">{{ channel.count }}</div>
                        </div>
                    </div>
                </div>
                <van-field label="总价:">
                    <template #input>
                        {{ selfCardDetail.total_amount }} 元
                    </template>
                </van-field>
                <van-field label="是否支付:">
                    <template #input>
                        <!-- {{ selfCardEnum['pay_status'] && selfCardEnum['pay_status'][selfCardDetail.is_pay] }} -->
                        {{ selfCardDetail.is_pay == 1 ? "是" : "否" }}
                        <span
                            class="link-text ml-10"
                            @click="throttleOpenPaymentHistoryPopup()"
                            v-if="selfCardDetail.is_pay == 1"
                        >查看支付记录</span>
                    </template>
                </van-field>
                <van-field label="采购时间:" v-show="selfCardDetail.purchase_time">
                    <template #input>
                        {{ moment(new Date(selfCardDetail.purchase_time)).format("YYYY-MM-DD") }}
                    </template>
                </van-field>
                <van-field label="开卡时间:" v-show="selfCardDetail.card_create_time">
                    <template #input>
                        {{ moment(new Date(selfCardDetail.card_create_time)).format("YYYY-MM-DD") }}
                    </template>
                </van-field>
                <van-field label="附件:">
                    <template #input>
                        <van-uploader
                            v-model="attachmentList"
                            :deletable="false"
                            :show-upload="false"
                            preview-size="75"
                            @click-preview="previewFile"
                            v-if="attachmentList.length > 0"
                            class="attachment-file-list"
                        />
                        <div v-else>暂时没有相关的附件</div>
                    </template>
                </van-field>
                <van-field label="备注:">
                    <template #input>
                        <span>{{ selfCardDetail.remark ? selfCardDetail.remark : "暂无" }}</span>
                    </template>
                </van-field>
            </van-form>
            <div class="button-section">
                <el-button
                    type="primary"
                    @click="copyDownloadLink(selfCardDetail.card_excel_url)"
                    v-if="selfCardDetail.card_excel_status === 3"
                    class="copy-download-link"
                >下载卡号密码</el-button>
                <el-button
                    type="primary"
                    @click="throttleCheckCardsExcelStatus(selfCardDetail.card_excel_status)"
                    v-else
                >当前状态: {{ selfCardDetail.card_excel_status_name }} (请点击刷新)</el-button>
                <el-button type="info" @click="openPaymentPopup()">新增付款信息</el-button>
            </div>
        </div>
        <!--  新增付款信息弹出层  -->
        <van-popup
            v-model="showAddPayment"
            position="bottom"
        >
            <div class="booking-home-search">
                <div class="booking-home-search-header">
                    <div @click="showAddPayment = false">取消</div>
                    <div>新增付款信息</div>
                    <div class="booking-submit" @click="addPayment()">确认</div>
                </div>
                <div class="booking-division" />
                <div class="booking-form">
                    <van-form ref="paymentForm">
                        <!-- 支付时间 -->
                        <van-field
                            readonly
                            clickable
                            name="pay_time"
                            right-icon="arrow"
                            :value="paymentForm.pay_time"
                            label="支付时间:"
                            placeholder="点击选择支付时间"
                            required
                            :rules="[{ required: true, message: '请选择支付时间' }]"
                            @click="openPicker('showPaymentCalendar')"
                        />
                        <van-popup
                            v-model="showPaymentCalendar"
                            position="bottom"
                            :style="{ height: '80%' }"
                            closeable
                            round
                        >
                            <van-calendar
                                :poppable="false"
                                :min-date="new Date('2020-01-01')"
                                :default-date="new Date()"
                                :lazy-render="true"
                                @confirm="onCalendarConfirm($event, 'showPaymentCalendar', 'pay_time')"
                            />
                        </van-popup>
                        <!-- 支付方式 -->
                        <van-field
                            name="pay_type"
                            label="支付方式:"
                            :rules="[{ required: true, message: '请选择支付方式' }]"
                            required
                        >
                            <template #input>
                                <van-radio-group
                                    v-model="paymentForm.pay_type"
                                    direction="horizontal"
                                >
                                    <van-radio
                                        checked-color="#DA0032"
                                        :key="key"
                                        :name="key"
                                        v-for="(value, key) in selfCardEnum.pay_type"
                                    >{{ value }}</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <!-- 支付金额 -->
                        <van-field
                            v-model="paymentForm.pay_money"
                            name="pay_money"
                            label="支付金额:"
                            placeholder="请输入金额"
                            type="digit"
                            required
                            @blur="forceUpdate"
                            :rules="[{ required: true, message: '请输入支付金额' }]"
                            @input="onPayMoneyChange"
                        >
                            <template #button>元</template>
                        </van-field>
                        <!-- 未支付金额 -->
                        <van-field label="未支付金额:">
                            <template #input>
                                {{ notPayMoney }} 元
                            </template>
                        </van-field>
                        <!-- 附件 -->
                        <van-field
                            label="附件:">
                            <template #input>
                                <!-- 图片选择，上传前判断格式，删除前做数据处理 -->
                                <van-uploader
                                    multiple
                                    upload-icon="plus"
                                    accept=""
                                    :max-count="10"
                                    v-model="paymentForm.fileList"
                                    :after-read="afterRead"
                                    preview-size="64" />
                            </template>
                        </van-field>
                    </van-form>
                </div>
            </div>
        </van-popup>
        <!--  支付记录弹出层  -->
        <van-popup
            v-model="showPaymentHistory"
            position="bottom"
        >
            <div class="booking-home-search">
                <div class="booking-home-search-header">
                    <div></div>
                    <div>支付记录</div>
                    <div class="booking-submit" @click="closePaymentHistoryPopup()">关闭</div>
                </div>
                <div class="booking-division" />
                <van-tabs>
                    <van-tab title="支付记录">
                    <el-table :data="payRecordList" :empty-text="'暂时没有支付记录!'" style="width: 100%">
                        <el-table-column prop="pay_time" label="支付时间" width="110">
                            <template slot-scope="scope">
                                {{ moment(new Date(scope.row.pay_time)).format("YYYY-MM-DD") }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_money" label="已支付金额" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.pay_money }}元
                            </template>
                        </el-table-column>
                        <el-table-column prop="not_pay_money" label="未支付金额" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.not_pay_money }}元
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_type_name" label="支付方式" width="100"></el-table-column>
                    </el-table>
                    </van-tab>
                    <van-tab title="附件">
                        <van-uploader
                            v-model="attachmentPayment"
                            :deletable="false"
                            :show-upload="false"
                            preview-size="64"
                            @click-preview="previewFile"
                            v-if="attachmentPayment.length > 0"
                            class="attachment-file-list"
                        />
                        <div v-else class="is-empty">暂时没有支付相关的附件</div>
                    </van-tab>
                </van-tabs>
            </div>
        </van-popup>
    </div>
</template>
<script>
import moment from "moment";
import selfCardService from "@/apis/selfCard/index.js";
import mixins from "./mixins/index.js";
import enums from "./mixins/enums.js";
import { Toast } from "vant";
// import * as dd from "dingtalk-jsapi";
import { throttle } from "@/utils/utils";
import Clipboard from 'clipboard';

export default {
    mixins: [enums, mixins],
    data() {
        return {
            // 自助制卡 ID
            record_id: 0,
            // 自助制卡详情
            selfCardDetail: {},
            // 自助制卡附件
            attachmentList: [],
            // 是否显示添加支付记录的弹窗
            showAddPayment: false,
            // 添加支付记录 form
            paymentForm: {
                pay_time: '',
                pay_type: '',
                pay_money: '',
                not_pay_money: '',
                // 附件的文件数组
                fileList: [],
            },
            // 是否显示支付时间的日历
            showPaymentCalendar: false,
            // 是否显示支付记录的弹窗
            showPaymentHistory: false,
            // 提交支付记录的状态
            submiting: false,
            // 支付记录
            payRecordList: [],
            // 支付记录附件
            attachmentPayment: [],
        };
    },
    computed: {
        serviceNames() {
            let text = ''
            if (this.selfCardDetail.service_list && this.selfCardDetail.service_list.length > 0) {
                this.selfCardDetail.service_list.forEach(service => {
                    text = text + service.service_name + '<br />'
                })
            } else {
                text = '暂无服务信息'
            }
            return text
        },
        notPayMoney () {
            const notPayMoney = this.paymentForm.not_pay_money - this.paymentForm.pay_money
            return isNaN(notPayMoney) || (notPayMoney < 0) ? 0 : Number(notPayMoney)
        }
    },
    async created() {
        this.record_id = Number(this.$route.query.record_id)
        this.getSelfCardDetail();
        // 按钮和连接做节流处理, 防止连续点击
        this.throttleOpenPaymentHistoryPopup = throttle(this.openPaymentHistoryPopup, 2000);
        // this.throttleDownloadCardsExcel = throttle(this.downloadCardsExcel, 3500);
        this.throttleCheckCardsExcelStatus = throttle(this.checkCardsExcelStatus, 3500);
    },
    methods: {
        moment,
        // 获取自助制卡详情
        getSelfCardDetail() {
            const { record_id } = this
            selfCardService.selfCardDetail({ record_id }).then((res) => {
                this.selfCardDetail = res;
                // 附件转换成 van-uploader 的格式
                if (res.file.length > 0) {
                    this.attachmentList = this.convertFilesToVanUploaderFormat(res.file)
                }
            });
        },
        // 打开日历
        openPicker(key) {
            this[key] = true;
        },
        // 日历选中时间后把日期显示在Input上, 同时关闭日历
        onCalendarConfirm(date, key, type) {
            this.paymentForm[type] = moment(date).format("YYYY-MM-DD");
            this[key] = false;
        },
        //  打开新增付款信息弹出层
        openPaymentPopup() {
            const { record_id } = this;
            selfCardService.getRecordNotPay({ record_id }).then((res) => {
                this.paymentForm.not_pay_money = res;
                this.showAddPayment = true;
            }).catch((err) => {
                console.log(err);
                Toast('获取未支付金额失败, 请重新点击"新增付款信息"按钮!');
            });
        },
        onPayMoneyChange(value) {
            if (Number(value) === 0) {
                Toast("支付金额不能为0元");
                this.paymentForm.pay_money = '';
            } else if (Number(value) > this.paymentForm.not_pay_money) {
                Toast("支付金额不能大于未支付金额");
                this.paymentForm.pay_money = '';
            }
        },
        // 上传附件
        async afterRead(file) {
            if(Array.isArray(file)) {
                file.forEach(async(item) => {
                    const url = await this.uploadFileOss(item)
                    if (url != false) {
                        item.url = url;
                    }
                })
            } else {
                const url = await this.uploadFileOss(file)
                if (url != false) {
                    file.url = url;
                }
            }
            console.log(this.paymentForm.fileList);
        },
        //  添加新增付款点后关闭弹出层
        addPayment() {
            if (this.submiting) {
                Toast("提交中，请勿重复点击");
                return false;
            }
            this.$refs.paymentForm.validate().then(() => {
                const params = {
                    record_id: this.record_id,
                    pay_time: this.paymentForm.pay_time,
                    pay_type: Number(this.paymentForm.pay_type),
                    pay_money: Number(this.paymentForm.pay_money),
                    not_pay_money: this.notPayMoney,
                    file: {
                        file_list: this.convertFilesToUploadFormat(this.paymentForm.fileList)
                    },
                    submit_user_id: this.currentUserInfo.user_id,
                    submit_user_name: this.currentUserInfo.user_name
                };
                this.submiting = true;
                selfCardService.payRecordAdd(params).then(() => {
                    this.submiting = false;
                    this.selfCardDetail.is_pay = 1
                    this.paymentForm.pay_time = ''
                    this.paymentForm.pay_type = []
                    this.paymentForm.pay_money = ''
                    this.paymentForm.fileList = []
                    this.showAddPayment = false
                }).catch(() => {
                    this.submiting = false;
                });
            }).catch((err) => {
                console.log(err);
            });
        },
        //  打开支付记录弹出层
        openPaymentHistoryPopup() {
            const { record_id } = this;
            selfCardService.getPayRecordList({ record_id }).then((res) => {
                let files = [];
                this.payRecordList = res;
                if (res.length > 0) {
                    res.forEach(item => {
                        if (item.file.length > 0) {
                            files = [ ...files, ...item.file ]
                        }
                    })
                }
                if (files.length > 0) {
                    this.attachmentPayment = this.convertFilesToVanUploaderFormat(files)
                }
                this.showPaymentHistory = true
            }).catch((err) => {
                console.log(err)
                Toast("获取支付记录失败, 请重试!");
            });
        },
        //  关闭支付记录弹出层
        closePaymentHistoryPopup() {
            this.showPaymentHistory = false
        },
        // 检测卡的 Excel 文件生成的状态
        checkCardsExcelStatus(status) {
            if (status == 1 || status == 4) {
                selfCardService.createCardsExcel({ record_id: this.record_id }).then(() => {
                    this.getSelfCardDetail()
                });
            } else {
                this.getSelfCardDetail()
            }
        },
        // 下载卡号密码 Excel
        /*
        downloadCardsExcel(url) {
            console.log(url)
            /*
            if (dd.env.platform !== "notInDingTalk") {
                Toast("请在系统自带浏览器中打开页面导出EXCEL");
                return;
            }
            this.downloadFile(url)
        },
        */
        // 复制下载卡号密码 Excel 的链接到剪切板
        copyDownloadLink(url) {
            let clipboard = new Clipboard('.copy-download-link', {
                text: function() {
                    return url
                }
            })
            clipboard.on('success', e => {
                Toast("下载链接复制成功, 请在系统自带浏览器中下载文件");
                e.clearSelection();
                clipboard.destroy();
            });
            clipboard.on('error', () => {
                Toast("此浏览器不支持自动复制功能");
            })
        },
        previewFile(file){
            const imageTypes = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'];
            const fileExt = file.file.name.split(".").pop();
            if (!imageTypes.includes(fileExt)) {
                let clipboard = new Clipboard('.attachment-file-list', {
                    text: function() {
                        return file.url
                    }
                })
                clipboard.on('success', e => {
                    Toast("附件下载链接复制成功, 请在系统自带浏览器中下载文件");
                    e.clearSelection();
                    clipboard.destroy();
                });
                clipboard.on('error', () => {
                    Toast("此浏览器不支持自动复制功能");
                })
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.self-card-detail {
    padding-bottom: 150px;
}
.link-text {
    cursor: pointer;
    color: blue;
}
.ml-10 {
    margin-left: 10px;
}
.button-section {
    max-width: 450px;
    position: fixed;
    bottom: 20px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .el-button {
        width: 100%;
        margin-top: 20px;
    }
    .el-button + .el-button {
        margin-left: 0px;
    }
}
.van-tab__pane {
    padding: 15px;
}
.attachment-list {
    margin-bottom: 5px;
    position: relative;
    padding-left: 14px;
    &::before {
        content: "";
        position: absolute;
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #66b1ff;
        left: 0;
        top: 8px;
    }
}
</style>